import { Navigate, useParams } from "react-router";
import { Spinner } from "@/components/ui/Spinner";
import { useTask } from "@/hooks/use-tasks";
import { draftOpeningPath } from "@/v2/stage-vocabulary";

/**
 * The bare draft address, as an email's resume link gives it: it opens the
 * stage the draft was last worked on, as the client's page does. Intake opens
 * a draft with no stage recorded, or one that could not be read. While the
 * draft is read it says so, rather than drawing Intake only to leave it.
 */
export function DraftOpening() {
  const { taskId = "" } = useParams();
  const { data: task, isError } = useTask(taskId);

  if (task === undefined && !isError) {
    return (
      <p className="flex items-center gap-2 py-10 text-sm text-muted-foreground">
        <Spinner size="sm" />
        Opening your draft…
      </p>
    );
  }
  return (
    <Navigate
      to={draftOpeningPath({
        task_id: taskId,
        last_stage: task?.last_stage ?? null,
      })}
      replace
    />
  );
}
